import React from 'react';
import { Section } from './ui/Section';
import { MapPin, Clock, CheckCircle, DollarSign } from 'lucide-react';
const features = [{
  icon: <MapPin className="h-6 w-6" data-id="element-166" />,
  title: 'Local & Licensed',
  description: "Based in PDX, fully licensed, bonded, and insured (CCB# 123456). We're your neighbors."
}, {
  icon: <Clock className="h-6 w-6" data-id="element-167" />,
  title: 'Fast Response',
  description: 'We actually answer the phone and show up when we say we will. Respecting your time is our priority.'
}, {
  icon: <CheckCircle className="h-6 w-6" data-id="element-168" />,
  title: 'Quality Work',
  description: 'We take pride in craftsmanship. No cutting corners, just solid work that lasts.'
}, {
  icon: <DollarSign className="h-6 w-6" data-id="element-169" />,
  title: 'Fair Pricing',
  description: "Transparent estimates with no hidden fees. You'll know exactly what you're paying for."
}];
export function WhyChooseUs() {
  return <Section id="why-us" background="primary" className="relative overflow-hidden bg-[#17a2b8]" data-id="element-170">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `radial-gradient(#ffffff 1px, transparent 1px)`,
      backgroundSize: '24px 24px'
    }} data-id="element-171" />

      <div className="relative z-10" data-id="element-172">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-173">
          <div data-id="element-174">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-175">
              Why Portland Homeowners and Businesses Trust Us
            </h2>
            <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-176">
              Finding a contractor for jobs can be frustrating. We're changing
              that by bringing professional standards to maintenance, repairs
              and remodels.
            </p>

            <div className="grid sm:grid-cols-2 gap-8" data-id="element-177">
              {features.map((feature, index) => <div key={index} className="flex flex-col gap-3" data-id="element-178">
                  <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center text-[#ff6b35] backdrop-blur-sm" data-id="element-179">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold text-white" data-id="element-180">
                    {feature.title}
                  </h3>
                  <p className="text-white/70 text-sm leading-relaxed" data-id="element-181">
                    {feature.description}
                  </p>
                </div>)}
            </div>
          </div>

          <div className="hidden lg:block relative" data-id="element-182">
            <div className="bg-[#faf8f5] p-8 rounded-2xl shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-183">
              <div className="flex flex-col gap-6" data-id="element-184">
                <div className="flex items-center gap-4 border-b border-gray-200 pb-4" data-id="element-185">
                  <div className="h-12 w-12 bg-gray-200 rounded-full flex items-center justify-center text-xl font-bold text-gray-500" data-id="element-186">
                    JS
                  </div>
                  <div data-id="element-187">
                    <div className="font-bold text-[#2c2c2c]" data-id="element-188">Jennifer S.</div>
                    <div className="text-sm text-gray-500" data-id="element-189">NE Portland</div>
                  </div>
                  <div className="ml-auto flex text-yellow-400" data-id="element-190">{'★★★★★'}</div>
                </div>
                <p className="text-[#525252] italic" data-id="element-191">
                  "Finally found a contractor who calls back! Fix & Finish
                  handled our list of repairs in one day. The work was perfect
                  and they left the place cleaner than they found it."
                </p>
              </div>
            </div>

            <div className="bg-[#faf8f5] p-8 rounded-2xl shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-500 mt-8 translate-x-8" data-id="element-192">
              <div className="flex flex-col gap-6" data-id="element-193">
                <div className="flex items-center gap-4 border-b border-gray-200 pb-4" data-id="element-194">
                  <div className="h-12 w-12 bg-gray-200 rounded-full flex items-center justify-center text-xl font-bold text-gray-500" data-id="element-195">
                    MR
                  </div>
                  <div data-id="element-196">
                    <div className="font-bold text-[#2c2c2c]" data-id="element-197">Mike R.</div>
                    <div className="text-sm text-gray-500" data-id="element-198">Beaverton</div>
                  </div>
                  <div className="ml-auto flex text-yellow-400" data-id="element-199">{'★★★★★'}</div>
                </div>
                <p className="text-[#525252] italic" data-id="element-200">
                  "Honest pricing and great communication. They fixed a leak
                  that two other handymen couldn't figure out. Highly
                  recommended."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}